import React from 'react';
import {Route, Switch, Redirect} from 'react-router';
import {getPlainPath} from 'epic-common/src/route';


import {
    ErrorView,
    InterviewView,
    SuccessView,
    PayoutView,
    CompetitiveView,
    ParticipationForm,
    SupportView
} from '../pages';

export function getStaticRoutes() {
    const path = getPlainPath();

    return [
        {path: `${path}/prizes`, exact: true, component: CompetitiveView},
        {path: `${path}/interview`, exact: true, component: InterviewView},
        {path: `${path}/participation`, exact: true, component: ParticipationForm},
        {path: `${path}/participation/:id`, exact: true, component: ParticipationForm},
        {path: `${path}/support`, exact: true, component: SupportView},
        {path: `${path}/payout`, exact: true, component: PayoutView},
        {path: `${path}/success`, exact: true, component: SuccessView},
        {path: `${path}/unexpected-error`, exact: true, render: () => <ErrorView status={500} />},
        {path: `${path}/error-404`, exact: true, render: () => <ErrorView status={404} />}
    ];
}

export function getRouteContent(location) {
    const path = getPlainPath();
    const routes = getStaticRoutes();

    const routeSwitch = (
        <Switch location={location}>
            {routes.map((route) => {
                return (
                    <Route key={route.path} {...route} />
                );
            })}
            <Redirect exact path={`${path}`} to={`${path}/prizes`} />
            <Redirect exact path={`${path}/esport`} to={`${path}/prizes`} />
            <Redirect exact path={`${path}/*`} to={`${path}/error-404`} />
        </Switch>
    );
    return routeSwitch;
}

export default getRouteContent;
